<div [ngClass]="footerContainerCSSClasses"
     class="d-flex flex-column flex-md-row align-items-center justify-content-between">
    <!--Version-->
    <div class='align-items-center'>
<!--        <div class="nav nav-dark">-->
<!--            <span class="d-flex align-items-center pl-0 pr-5">Data Versiune: 03/06/2022</span>-->
<!--            <span class="d-flex align-items-center pl-0 pr-5">Versiune - 1.2</span>-->
<!--        </div>-->
    </div>

    <!--FeedBack-->
    <!-- <div class="text-dark">
        <app-feedback></app-feedback>
    </div> -->
</div>

